import { useWindowDimensions } from 'react-native'

export function useScreenSize() {
  const { height } = useWindowDimensions()

  // Add additional breakpoints as needed (e.g. isTall).
  const isShort = height < 700

  return { isShort }
}
